import React, { useEffect, useState } from "react";
// ANT DESIGN COMPONENTS
import { Card } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlugCircleCheck } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useLazyGetOrganizationAndChildsQuery } from "../../redux/organizations/organizationAPI";
// COMPONENTS
import SelectOrganizationsLight from "../components/select/SelectOrganizationsLight";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";

export default function DashboardOrganizationDetails() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [idOrganization, setIdOrganization] = useState<string>("");
  const [, setOrganization] = useState<any>({});

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const [triggerGetOrganization, { data, isLoading, isFetching }] =
    useLazyGetOrganizationAndChildsQuery();

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChangeIdOrganization = (newValue: string) => {
    setIdOrganization(newValue);
  };

  const launchGetOrganization = async () => {
    const token = await GETJwtToken();
    triggerGetOrganization({
      token,
      orgId: idOrganization,
    });
  };

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    if (idOrganization) {
      launchGetOrganization();
    }
  }, [idOrganization]);

  useEffect(() => {
    if (data && data.data) {
      setOrganization(data.data);
    }
  }, [data]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <SelectOrganizationsLight
        value={idOrganization}
        onChangeIdOrganization={onChangeIdOrganization}
        disabledInput={false}
      />
      <Card
        loading={isLoading || isFetching}
        hoverable
        className="generalStyles__dashboardCard"
        title={
          <div>
            <FontAwesomeIcon
              icon={faPlugCircleCheck}
              className="generalStyles__info generalStyles__mrFix"
            />
            <span>Network</span>
          </div>
        }
        style={{ margin: "10px" }}
      >
        Hello Card
      </Card>
    </div>
  );
}
